import { ref, computed } from "vue";

export function useIsLoading() {

  const loadingOperations = ref(new Set());

  const isLoading = computed(() => loadingOperations.value.size > 0);

  const setIsLoading = (value: boolean, id = "default") => {
    if (value) {
      loadingOperations.value.add(id);
      setTimeout(() => {
        loadingOperations.value.delete(id);
      }, 3000); 
    } else {
      loadingOperations.value.delete(id);
    }
  };

  return { isLoading, setIsLoading };
}
